import React, { useEffect, useState } from 'react';

export default function ReceiveOrder() {
  const [raw, setRaw] = useState(null);
  const [normalized, setNormalized] = useState(null);
  const [html, setHtml] = useState("");
  const [showDev, setShowDev] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await fetch("/api/transport-last");
        const json = await res.json();
        setRaw(json.raw || null);
        setNormalized(json.normalized || null);
        // If server didn't provide an HTML payload, synthesize a simple HTML fallback from normalized
        let htmlPayload = json.html || "";
        if ((!htmlPayload || htmlPayload === "") && (json.normalized || json.saved)) {
          const n = json.normalized || json.saved || {};
          const rows = [];
          rows.push(`<div><strong>Customer Name:</strong> ${n.customer_name || ''}</div>`);
          rows.push(`<div><strong>Customer Email:</strong> ${n.customer_email || ''}</div>`);
          rows.push(`<div><strong>Customer Phone:</strong> ${n.customer_phone || ''}</div>`);
          rows.push(`<div><strong>Address:</strong> ${[n.customer_address_line1, n.customer_address_line2, n.customer_address_city, n.customer_address_state, n.customer_address_zip, n.customer_address_country].filter(Boolean).join(' ')}</div>`);
          if (Array.isArray(n.items) && n.items.length) {
            rows.push('<div><strong>Items:</strong></div>');
            rows.push('<ul>');
            for (const it of n.items) {
              rows.push(`<li>${it.item_title || it.item_productId || ''} — Qty: ${it.item_qty || 0} — $${Number(it.item_price || 0).toFixed(2)}</li>`);
            }
            rows.push('</ul>');
          } else {
            rows.push(`<div><strong>Items:</strong> None</div>`);
          }
          rows.push(`<div><strong>Subtotal:</strong> $${Number(n.summary_subtotal || 0).toFixed(2)}</div>`);
          rows.push(`<div><strong>Shipping:</strong> $${Number(n.summary_shippingCost || 0).toFixed(2)}</div>`);
          rows.push(`<div><strong>Fees:</strong> $${Number(n.summary_fees || 0).toFixed(2)}</div>`);
          rows.push(`<div><strong>Total:</strong> $${Number(n.summary_total || 0).toFixed(2)}</div>`);
          htmlPayload = rows.join('\n');
        }
        setHtml(htmlPayload);
      } catch (err) {
        setError(String(err));
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  return (
    <div className="min-h-screen p-6 surface text-left">
      <h2 className="text-ice text-2xl font-semibold mb-4">Receive Order — Developer View</h2>

      {/* Developer toggle removed per request */}

      {showDev && (
        <>
          <h3 className="text-xl text-green-400 mt-6">Raw JSON:</h3>
          <pre className="p-4 rounded bg-gray-900 text-green-300 text-sm overflow-auto">{JSON.stringify(raw, null, 2)}</pre>

          <h3 className="text-xl text-blue-400 mt-6">Normalized JSON:</h3>
          <pre className="p-4 rounded bg-gray-900 text-blue-300 text-sm overflow-auto">{JSON.stringify(normalized, null, 2)}</pre>
        </>
      )}

      

      <h3 className="text-3xl text-blue-400 mt-6">HTML View</h3>

      {/* Black & white HTML View block (compact, left-aligned) */}
      <div className="p-6 rounded bg-black text-white text-sm leading-relaxed mt-3">
        <div className="mb-2"><strong>Customer Name:</strong> {normalized?.customer_name || ''}</div>
        <div className="mb-2"><strong>Customer Email:</strong> {normalized?.customer_email || ''}</div>
        <div className="mb-2"><strong>Customer Phone:</strong> {normalized?.customer_phone || ''}</div>
        <div className="mb-2"><strong>Address:</strong> {normalized ? `${normalized.customer_address_line1 || ''} ${normalized.customer_address_line2 || ''}, ${normalized.customer_address_city || ''} ${normalized.customer_address_state || ''} ${normalized.customer_address_zip || ''} ${normalized.customer_address_country || ''}` : ''}</div>
        <div className="mb-2"><strong>Items:</strong> {Array.isArray(normalized?.items) && normalized.items.length ? (
          <ul className="list-disc pl-5">
            {normalized.items.map((it, idx) => (
              <li key={idx} className="text-white">{it.item_title || it.item_productId || 'Item'} — Qty: {it.item_qty || 0} — ${Number(it.item_price || 0).toFixed(2)}</li>
            ))}
          </ul>
        ) : ' None'}</div>
        <div className="mb-2"><strong>Subtotal:</strong> ${Number(normalized?.summary_subtotal || 0).toFixed(2)}</div>
        <div className="mb-2"><strong>Shipping:</strong> ${Number(normalized?.summary_shippingCost || 0).toFixed(2)}</div>
        <div className="mb-2"><strong>Fees:</strong> ${Number(normalized?.summary_fees || 0).toFixed(2)}</div>
        <div className="mb-2"><strong>Total:</strong> ${Number(normalized?.summary_total || 0).toFixed(2)}</div>
        <div className="mb-2"><strong>Currency:</strong> {normalized?.currency || 'USD'}</div>
        <div className="mb-2"><strong>Shipping Method:</strong> {normalized?.shipping_method || ''}</div>
        <div className="mb-2"><strong>Tracking Requested:</strong> {String(normalized?.tracking_requested || false)}</div>
        <div className="mb-2"><strong>Metadata Session:</strong> {normalized?.metadata_session || ''}</div>
        <div className="mb-2"><strong>Referrer:</strong> {normalized?.referrer || ''}</div>
        <div className="mb-2"><strong>Browser:</strong> {normalized?.browser || ''}</div>
        <div className="mb-2"><strong>IP:</strong> {normalized?.ip || ''}</div>
      </div>
      

      {/* Rendered HTML removed per request */}

      <a
        href="/sales-center"
        className="mt-6 inline-block px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
      >
        Open Sales Center →
      </a>
    </div>
  );
}
